import uuid from 'uuid'

export const defaultRecipeSteps = defaultLocale => ({
  categories: [{
    type: 'preparation',
    title: {
      [defaultLocale]: 'Preparation Steps',
    },
    steps: [],
  }, {
    type: 'cooking',
    title: {
      [defaultLocale]: 'Cooking steps',
    },
    steps: [],
  }],
})

export const defaultParams = [[
  { field: 'stepParameter1', title: 'Step Parameter 1' },
  { field: 'stepParameter2', title: 'Step Parameter 2' },
  { field: 'stepParameter3', title: 'Step Parameter 3' },
], [
  { field: 'stepText1', title: 'Step Text 1' },
  { field: 'stepText2', title: 'Step Text 2' },
], [
  { field: 'stepDuration1', title: 'Step Duration 1' },
  { field: 'stepDuration2', title: 'Step Duration 2' },
],[
  { field: 'stepPower1', title: 'Step Power 1' },
  { field: 'stepPower2', title: 'Step Power 2' },
],
]

export const parametersByType = {
  kettle: [[
    { field: 'stepDuration1', title: 'Time' }, { field: 'stepParameter1', title: 'Temperature' },
  ]],
  blender: [[
    { field: 'stepDuration1', title: 'Time' }, { field: 'stepParameter1', title: 'Speed' },
  ]],
  scale: [[
    { field: 'stepParameter1', title: 'Target Weight' }, { field: 'stepParameter2', title: '+/- Target Margin' },
  ]],
}

export const getPrametersByType = type => parametersByType[type] || defaultParams

export const newStep = ({
  defaultLocale,
  title,
  type,
  ...additionalParams
}) => ({
  stepNewKey: uuid(),
  title: {
    [defaultLocale]: title,
  },
  type,
  showTime: false,
  requiresUserConfirmation: false,
  disableSounds: false,
  disableReminder: false,
  scalable: false,
  stepJumpStart: 0,
  stepJumpLength: 0,
  stepParameter1: 0,
  stepParameter2: 0,
  stepParameter3: 0,
  stepText1: 0,
  stepText2: 0,
  stepDuration1: 0,
  stepDuration2: 0,
  stepPower1: 0,
  stepPower2: 0,
  ...additionalParams,
})
